'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = require('lodash');

var _validationConstants = require('../../validationConstants');

var OBJECT_ERROR_OBJECT = {
    name: _validationConstants.FAILURE_NAMES.object,
    type: _validationConstants.FAILURE_TYPES.ERROR,
    message: 'Must be a string'
};

exports.default = function (fieldValue, validationConfig) {
    if (!fieldValue) return;

    if (!(0, _lodash.isString)(fieldValue)) return OBJECT_ERROR_OBJECT;

    return null;
};


//////////////////
// WEBPACK FOOTER
// ./src/common/validation/validators/type/htmlValidator.js
// module id = 2305
// module chunks = 0